import { useQuery } from '@tanstack/react-query';

import { useApi } from 'services/api';
import { prepareTimerangeQueryWithSeconds } from 'utils/pql';
import { getConfiguredTimezone } from 'utils/datetime';

export default function useSensorBandwidthVolume({ sensorId, fromTime, toTime }) {
  const api = useApi();
  const timezone = getConfiguredTimezone();

  return useQuery({
    queryKey: ['sensorBandwidthVolume', { sensorId, fromTime, toTime }],
    queryFn: async () => {
      // slice the fromTime and toTime into 4 hours chunks
      const intervals = [];
      for (let i = fromTime; i < toTime; i = new Date(i.getTime() + 4 * 60 * 60 * 1000)) {
        intervals.push([new Date(i), new Date(Math.min(i.getTime() + 4 * 60 * 60 * 1000, toTime.getTime()))]);
      }

      const results = await Promise.all(
        intervals.map(([from, to]) =>
          api
            .get('/search/query', {
              params: {
                query: `${prepareTimerangeQueryWithSeconds(from, to)} limit 10000 | orderby ts asc`,
                context: [sensorId],
                timezone,
                searchType: 'O_SENSOR_STATS',
              },
            })
            .then((r) => r.results),
        ),
      );

      return results.flat().sort((a, b) => a.ts_sensor_millis - b.ts_sensor_millis);
    },
  });
}
